import { render, staticRenderFns } from "./ContactUs.vue?vue&type=template&id=87b8ab1e&scoped=true"
import script from "./ContactUs.vue?vue&type=script&lang=js"
export * from "./ContactUs.vue?vue&type=script&lang=js"
import style0 from "./ContactUs.vue?vue&type=style&index=0&id=87b8ab1e&prod&lang=scss&scoped=true"
import style1 from "./ContactUs.vue?vue&type=style&index=1&id=87b8ab1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b8ab1e",
  null
  
)

export default component.exports